import { $isUserGamedPremium, $userLanguage } from '@/entities/user'
import { Icon, TIconVariant } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { formatNumber } from '@/shared/util/formatNumber'

type DailyBonusWrapperProps = {
  amount: number
  rewardKind: number
  isClaimed: boolean
  isShowingLocker: boolean
  isDisabled: boolean
  onClick: () => void
  isLoading: boolean
  protoStyles?: React.CSSProperties
  imgStyles?: React.CSSProperties
} & React.CSSProperties

enum RewardKindFolder {
  'gamed' = 1,
  'subscription' = 2,
  'keys' = 3,
  'tgStar' = 4,
  'playstation' = 5,
}

export const DailyBonusWrapper = ({
  amount,
  rewardKind = 1,
  isClaimed,
  isShowingLocker,
  isDisabled,
  isLoading,
  onClick,
  protoStyles,
  imgStyles,
  ...styles
}: DailyBonusWrapperProps) => {
  const { classes } = useStyles()
  const isPlusUser = useUnit($isUserGamedPremium)

  // костыль для 10к премиуму. и картинка 3000 кривая.
  const amt = amount === 3000 ? 2500 : isPlusUser && amount === 3 && rewardKind === 2 ? 10000 : amount

  const rkind = isPlusUser && amount === 3 && rewardKind === 2 ? 1 : rewardKind
  const imgSrc = `assets/lootBoxRelated/rewardsPreview/dailybonus/${RewardKindFolder[rkind]}/${amt}.png`

  const needTopIcon = isShowingLocker || isClaimed

  return (
    <div
      className={classes.proto}
      style={protoStyles}
    >
      {isLoading && (
        <div className={classes.loadingWrapper}>
          <Icon
            view="throbber"
            width={32}
          />
        </div>
      )}
      <div
        className={classes.root}
        onClick={onClick}
        data-isdisabled={isDisabled}
        data-isloading={isLoading}
        style={styles}
      >
        {needTopIcon && (
          <div className={classes.lockedIconWrapper}>
            <Icon
              view={isClaimed ? 'whiteChecked' : 'whiteLock'}
              width={16}
            />
          </div>
        )}

        <div
          className={classes.imgWrapper}
          style={imgStyles}
        >
          <img
            src={imgSrc}
            alt=""
            data-isclaimed={isClaimed}
          />
        </div>
        <div className={classes.textWrapper}>
          <RenderRewardName
            rewardKind={rkind}
            amount={amt}
            isClaimed={isClaimed}
          />
        </div>
      </div>
    </div>
  )
}

const RenderRewardName = ({
  rewardKind,
  amount,
  isClaimed,
}: {
  rewardKind: number
  amount: number
  isClaimed: boolean
}) => {
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.dailyBonus
  const { classes } = useStyles()
  if (isClaimed) {
    return <span className={classes.amountText}>{lang[userLang].pages.dailyBonus.claimed}</span>
  }
  if (rewardKind === 1) {
    return (
      <>
        <span className={classes.amountText}>{formatNumber(amount)}</span>
        <Icon
          style={{ alignSelf: 'center' }}
          view={RewardKindFolder[rewardKind] as TIconVariant}
        />
      </>
    )
  }
  if (amount == 69) {
    return <span className={classes.smallText}>{texts.playStation}</span>
  }

  if (rewardKind === 2) {
    return (
      <span
        className={classes.amountText}
        style={{ position: 'relative', fontSize: '17px', top: '8px' }}
      >
        GAMED Plus
      </span>
    )
  }
  if (rewardKind === 3) {
    return (
      <span className={classes.amountText}>
        {amount === 1 ? texts.key : texts.keys}
        {' x'}
        {amount}
      </span>
    )
  }
  if (rewardKind === 4) {
    return (
      <>
        <span className={classes.amountText}>{formatNumber(amount)}</span>
        <Icon
          style={{ alignSelf: 'center' }}
          view={RewardKindFolder[rewardKind] as TIconVariant}
        />
      </>
    )
  }
  if (amount == 69) {
    return <span className={classes.smallText}>6 month of GAMED plus</span>
  }
  if (rewardKind === 5) {
    return <span className={classes.smallText}>6 month of GAMED plus & chance to Win PS5</span>
  }
}
